import { createContext } from "react";
import { INIT_LOADING_REQUEST } from "components/Preloader/utils/constants";

const EventFormContext = createContext({
	data: {
		payGrades: [],
		eventTypes: [],
		eventSubtypes: [],
		eventGraphics: [],
		organizers: [],
		teacherAccounts: [],
		complementaryServiceAreas: [],
		extracurricularSections: [],
		certificationSignatureTypes: [],
	},
	isCreate: true,
	isWorkshopEventType: false,
	loadingRequest: {
		value: { ...INIT_LOADING_REQUEST },
		hide: () => {},
		show: message => {},
	},
});

export default EventFormContext;
